var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-infinite-scroll",on:{"scroll":function($event){return _vm.$_onScroll($event)}}},[_vm._t("default",null,{"items":_vm.items}),(_vm.fetching)?_c('WsLoading'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }